const modal = document.querySelector("#sizeGuideModal");
const overlay = document.querySelector(".sizeGuide-overlay");
const openModalBtn = document.querySelector(".size-guide-open");
const typesArray = ["tees", "onesies", "rompers", "sleeper_pajamas", "tops", "bottoms", "adult_tee", "adult_jogger", "adult_hoodie", "adult_crew"];
const closeModalBtn = document.querySelector("#sizeGuideModal .btn-close");

const tabKeywords = {
  "adult_tee": ["adult", "tee"],
  "adult_jogger": ["adult", "jogger"],
  "adult_hoodie": ["adult", "hoodie"],
  "adult_crew": ["adult", "crew", "pullover"]
};

const selectBestTab = function () {
  const dataTags = openModalBtn.getAttribute('data-tags')?.toLowerCase().split(',') || [];
  const dataType = openModalBtn.getAttribute('data-type')?.toLowerCase() || '';
  const dataTitle = openModalBtn.getAttribute('data-title')?.toLowerCase() || '';

  let bestTab = null;
  let highestScore = -1;

  // --- tabKeywords ---
  for (const [tab, keywords] of Object.entries(tabKeywords)) {
    let score = 0;

    keywords.forEach(kw => {
      if (dataTitle.includes(kw)) score += 2;
      if (dataType.includes(kw)) score += 1;
      if (dataTags.some(tag => tag.includes(kw))) score += 1;
    });

    if (score > highestScore) {
      highestScore = score;
      bestTab = tab;
    }
  }

  // --- typesArray ---
  typesArray.forEach(type => {
    let score = 0;
    if (dataTitle.includes(type)) score += 1;
    if (dataType.includes(type)) score += 1;
    if (dataTags.some(tag => tag.includes(type))) score += 1;

    if (typesArray.includes(type) && document.querySelector(`.tab-link[data-tab="${type}"]`)) {
      if (score > highestScore) {
        highestScore = score;
        bestTab = type;
      }
    }
  });

  if (!bestTab) bestTab = "tee";

  const tabEl = document.querySelector(`.tab-link[data-tab="${bestTab}"]`);
  if (tabEl) {
    tabEl.click();
  
    tabEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
};

const showDialog = () => {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.overflow = "hidden";
  body.style.top = `-${scrollY}`;
};

const closeDialog = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.overflow = "";
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

const closeModal = function () {
  modal.classList.add("hidden");
  overlay.classList.add("hidden");
  closeDialog()
};

closeModalBtn.addEventListener("click", closeModal);
overlay.addEventListener("click", closeModal);

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && !modal.classList.contains("hidden")) {
    closeModal();
  }
});

const openModal = function () {
  modal.classList.remove("hidden");
  overlay.classList.remove("hidden");
  showDialog();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      selectBestTab();
    });
  });
};

openModalBtn.addEventListener("click", openModal);


document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-link');
  const panels = document.querySelectorAll('.tab-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const target = tab.getAttribute('data-tab');
      document.getElementById(target).classList.add('active');
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('unitToggle');
  const rows = document.querySelectorAll('#sizeChart tr[data-unit]');

  if (!toggle) return;

  const updateUnits = () => {
    const unit = toggle.checked ? 'cm' : 'in';

    rows.forEach(row => {
      row.style.display = row.dataset.unit === unit ? 'table-row' : 'none';
    });
  };

  toggle.addEventListener('change', updateUnits);

  updateUnits();
});
